export const INIT_CATEGORY = 'INIT_CATEGORY'
export const INIT_SUB_CATEGORY = 'INIT_SUB_CATEGORY'
export const INIT_GOODS_BY_CATEGORY = 'INIT_GOODS_BY_CATEGORY'



// WEBPACK FOOTER //
// ./src/logic/category/mutation-types.js